module.exports = __webpack_public_path__ + "img/logo-desktop.e0fc7ea2.svg";